// Polyfill for the BootstrapVue 2 `this.$bvModal` API on top of
// bootstrap-vue-next's useModal() composable. Existing components call
// $bvModal.show('id') and $bvModal.hide('id') from methods (outside setup
// context), so we install a global property that lazily resolves the
// orchestrator controller via app.runWithContext().

import { h } from 'vue'
import { useModal } from 'bootstrap-vue-next'

export default {
  install (app) {
    let api = null
    const getApi = () => {
      if (!api) {
        api = app.runWithContext(() => useModal())
      }
      return api
    }

    // BVN's `body` prop renders as plain text and create() starts hidden, so render the
    // HTML through the default slot and show() it. Needs <b-orchestrator> mounted (App.vue).
    const msgBox = (message, options) => {
      const html = typeof message === 'string' ? message : ''
      return getApi().create({
        ...options,
        slots: { default: () => h('div', { innerHTML: html }) }
      }).show()
    }

    app.config.globalProperties.$bvModal = {
      show (id) {
        // BVN's show(id) only searches open/created modals, so a closed <b-modal id> in a template
        // never opens; get(id) also searches the registry of mounted modals.
        const modal = getApi().get(id)
        return modal ? modal.show() : getApi().show(id)
      },
      hide (id, trigger) {
        // BV2 signature: hide(id, trigger?). BVN's hide is hide(trigger, id).
        const modal = getApi().get(id)
        return modal ? modal.hide(trigger) : getApi().hide(trigger, id)
      },
      hideAll (trigger) {
        return getApi().hideAll(trigger)
      },
      // Programmatic ok-only message box. BV2 callers pass either a string or
      // a VNode; we render strings as HTML body. VNode callers should be
      // migrated to pass a string or use create() directly.
      msgBoxOk (message, options = {}) {
        return msgBox(message, { okOnly: true, ...options })
      },
      msgBoxConfirm (message, options = {}) {
        return msgBox(message, { okTitle: 'OK', cancelTitle: 'Cancel', ...options })
      }
    }
  }
}
